(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buildings"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.buildings').forEach((root) => {
    root.querySelectorAll('.bcard__hit').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.bcard'); const panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
        const open = card.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(open)); if (panel) panel.hidden = !open;
      });
    });
    root.querySelectorAll('[data-city]').forEach((chip) => {
      if (!chip.classList.contains('chip')) return;
      chip.addEventListener('click', () => {
        const city = chip.dataset.city;
        root.querySelectorAll('.buildings__filter .chip').forEach((c) => { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-selected', String(c === chip)); });
        root.querySelectorAll('.bcard').forEach((card) => { card.hidden = !!city && card.dataset.city !== city; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["festive-band"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-festive-countdown]').forEach((el) => {
    // Offer ends at the end of the given day, India time (UTC+5:30).
    const end = new Date(`${el.dataset.ends}T23:59:59+05:30`).getTime();
    if (Number.isNaN(end)) return;
    const d = el.querySelector('[data-cd-d]');
    const h = el.querySelector('[data-cd-h]');
    const m = el.querySelector('[data-cd-m]');
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) { el.closest('.festive')?.setAttribute('hidden', ''); return; }
      d.textContent = pad(Math.floor(left / 86400000));
      h.textContent = pad(Math.floor(left / 3600000) % 24);
      m.textContent = pad(Math.floor(left / 60000) % 60);
    };
    tick();
    setInterval(tick, 30000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-demo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-home-demo]').forEach((root) => {
    const S = { ceiling: true, bri: 80, strip: true, color: '#FFC27A', curtain: 'open', lock: 'locked', night: false };
    const $ = (s) => root.querySelector(s);
    const statusEl = root.querySelector('[data-hd-status]');
    const slider = root.querySelector('[data-hd-bri]');
    let statusTimer;

    const say = (msg) => {
      if (!statusEl) return;
      statusEl.textContent = msg;
      clearTimeout(statusTimer);
      statusTimer = setTimeout(() => { statusEl.textContent = S.night ? 'Living room · good night' : 'Living room · everything calm'; }, 2600);
    };

    const render = () => {
      const lit = S.ceiling ? S.bri / 100 : 0;
      // ambient light of the whole band follows the room
      root.style.setProperty('--bri', (S.night ? lit * 0.5 : lit).toFixed(2));
      root.style.setProperty('--night', S.night ? 1 : 0);
      root.style.setProperty('--accent', S.ceiling ? S.color : '#2A2438');
      root.style.setProperty('--strip', S.color);
      root.dataset.curtain = S.curtain;
      root.dataset.lock = S.lock;
      root.dataset.strip = S.strip ? 'on' : 'off';

      const setTile = (key, on, label) => {
        const tile = root.querySelector(`[data-hd-toggle="${key}"]`);
        const state = root.querySelector(`[data-hd-state="${key}"]`);
        if (tile) { tile.classList.toggle('is-on', on); tile.style.setProperty('--tile-accent', S.color); }
        if (state) state.textContent = label;
      };
      setTile('ceiling', S.ceiling, S.ceiling ? `On · ${S.bri}%` : 'Off');
      setTile('strip', S.strip, S.strip ? 'On' : 'Off');
      setTile('curtain', S.curtain === 'open', S.curtain === 'open' ? 'Open' : 'Closed');
      setTile('lock', S.lock === 'locked', S.lock === 'locked' ? 'Locked' : 'Unlocked');

      const briLabel = root.querySelector('[data-hd-bri-label]');
      if (briLabel) briLabel.textContent = `${S.bri}%`;
      if (slider) { slider.value = S.bri; slider.style.setProperty('--fill', `${S.bri}%`); }
      const meta = root.querySelector('[data-hd-meta]');
      if (meta) meta.textContent = S.night ? 'Good night · 4 devices resting' : 'Good evening · 6 devices ready';
      root.querySelectorAll('[data-hd-color]').forEach((b) => b.classList.toggle('is-active', b.dataset.hdColor === S.color));
    };

    root.querySelectorAll('[data-hd-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const k = btn.dataset.hdToggle;
        if (k === 'ceiling') { S.ceiling = !S.ceiling; say(S.ceiling ? 'Ceiling lights on' : 'Ceiling lights off'); }
        if (k === 'strip') { S.strip = !S.strip; say(S.strip ? 'TV backlight on' : 'TV backlight off'); }
        if (k === 'curtain') { S.curtain = S.curtain === 'open' ? 'closed' : 'open'; say(S.curtain === 'open' ? 'Curtains opening' : 'Curtains closing'); }
        if (k === 'lock') { S.lock = S.lock === 'locked' ? 'unlocked' : 'locked'; say(S.lock === 'locked' ? 'Front door locked' : 'Front door unlocked'); }
        render();
      });
    });

    slider?.addEventListener('input', () => { S.bri = parseInt(slider.value, 10); if (S.bri > 5) S.ceiling = true; render(); });

    root.querySelectorAll('[data-hd-color]').forEach((btn) => {
      btn.addEventListener('click', () => { S.color = btn.dataset.hdColor; S.strip = true; say('Backlight colour changed'); render(); });
    });

    // Scenes run as a short sequence — the point of automation, not a single switch.
    const steps = (list) => list.forEach(([ms, fn]) => setTimeout(() => { fn(); render(); }, ms));
    const siriText = root.querySelector('[data-hd-siri-text]');
    root.querySelectorAll('[data-hd-scene]').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.classList.add('is-firing');
        setTimeout(() => btn.classList.remove('is-firing'), 400);
        const s = btn.dataset.hdScene;
        if (s === 'night') {
          if (siriText) siriText.textContent = '“Hey Siri, good night”';
          say('Running “Good night”…');
          steps([[0, () => { S.night = true; S.lock = 'locked'; }], [450, () => { S.curtain = 'closed'; }], [1100, () => { S.bri = 15; S.color = '#FFC27A'; }], [1700, () => { S.strip = false; }], [2300, () => { S.ceiling = false; say('Good night — house secured'); }]]);
        }
        if (s === 'movie') {
          if (siriText) siriText.textContent = '“Hey Siri, movie night”';
          say('Running “Movie night”…');
          steps([[0, () => { S.night = true; S.curtain = 'closed'; }], [600, () => { S.bri = 20; S.ceiling = true; }], [1100, () => { S.strip = true; S.color = '#C85BD0'; say('Movie night — backlight on'); }]]);
        }
        if (s === 'wake') {
          if (siriText) siriText.textContent = '“Hey Siri, wake up”';
          say('Running “Wake up”…');
          steps([[0, () => { S.night = false; S.curtain = 'open'; }], [500, () => { S.ceiling = true; S.bri = 45; S.color = '#FFC27A'; }], [1200, () => { S.bri = 90; }], [1800, () => { S.strip = false; S.lock = 'unlocked'; say('Good morning'); }]]);
        }
      });
    });

    const clock = root.querySelector('[data-hd-clock]');
    if (clock) {
      const tick = () => { clock.textContent = new Date().toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: false }); };
      tick(); setInterval(tick, 30000);
    }
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-lead-section]').forEach((sec) => {
      const form = sec.querySelector('[data-lead-form]');
      const bar = sec.querySelector('[data-lead-bar]');
      const success = sec.querySelector('[data-lead-success]');
      // Hide the sticky bar while the form card is on screen
      if (bar && form && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => bar.classList.toggle('is-hidden', en.isIntersecting), { threshold: 0.15 });
        io.observe(form);
      }
      // Conversion event after a successful post (page reloads with the success block)
      if (success) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'generate_lead', lead_type: 'turnkey_consultation', page: location.pathname });
        if (typeof fbq === 'function') fbq('track', 'Lead', { content_name: 'turnkey_consultation' });
        const card = success.closest('.lead__card'); if (card && location.hash) card.scrollIntoView({ block: 'center' });
      }
      if (!form) return;
      form.addEventListener('submit', (e) => {
        const hp = form.querySelector('[data-honeypot]');
        if (hp && hp.value) { e.preventDefault(); return; }
        const btn = form.querySelector('[data-lead-submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
        // Mirror to Zoho CRM Web-to-Lead (fire-and-forget; keepalive survives the page navigation)
        const cfg = (window.Nova && window.Nova.leads) || {};
        if (cfg.zohoUrl && cfg.zohoXnQsjsdp && cfg.zohoXmIwtLD) {
          try {
            const fd = new FormData();
            fd.append('xnQsjsdp', cfg.zohoXnQsjsdp); fd.append('xmIwtLD', cfg.zohoXmIwtLD);
            fd.append('actionType', 'TGVhZHM='); fd.append('returnURL', location.href);
            if (cfg.leadSource) fd.append('Lead Source', cfg.leadSource);
            form.querySelectorAll('[data-zoho]').forEach((el) => { if (el.value) fd.append(el.dataset.zoho, el.value); });
            const extra = ['contact[Property type]', 'contact[Stage]', 'contact[Budget]'].map((n) => { const el = form.elements[n]; return el && el.value ? `${n.replace('contact[', '').replace(']', '')}: ${el.value}` : ''; }).filter(Boolean).join(' | ');
            const body = form.elements['contact[body]'];
            fd.set('Description', [body && body.value, extra, 'Page: ' + location.href].filter(Boolean).join('\n'));
            fetch(cfg.zohoUrl, { method: 'POST', mode: 'no-cors', body: fd, keepalive: true });
          } catch (err) { /* never block the Shopify submission */ }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-logo-more]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const grid = btn.closest('.logo-wall').querySelector('[data-logo-wall]');
      const open = grid.classList.toggle('is-expanded');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
